module.exports = __webpack_public_path__ + "img/ryzhkov_serhiy.54cb356d.png";